import React from 'react';
import PropTypes from 'prop-types';

import { MuiThemeProvider as NewMuiThemeProvider, createMuiTheme } from 'material-ui-next/styles';

import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { fade } from 'material-ui/utils/colorManipulator';
import injectTapEventPlugin from 'react-tap-event-plugin';

import AppConstants from './constants/AppConstants';

// Needed for onTouchTap (material-ui)
// http://stackoverflow.com/a/34015469/988941 
injectTapEventPlugin();

// This replaces the textColor value on the palette
// and then update the keys for each component that depends on it.
// More on Colors: http://www.material-ui.com/#/customization/colors
let muiThemeNew = createMuiTheme({
  palette: {
    primary: {
      main: AppConstants.colors.primary1Color,
      dark: '#000'
    },
    secondary: {
      main: AppConstants.colors.accent1Color,
    },
  },
});
let muiTheme = getMuiTheme({
  palette: {
    primary1Color: AppConstants.colors.primary1Color, //indigo500,
    primary2Color: AppConstants.colors.primary2Color, //indigo700,
    accent1Color: AppConstants.colors.accent1Color,
    accent2Color: AppConstants.colors.accent2Color,
    pickerHeaderColor: AppConstants.colors.primary2Color, //indigo500,
  },
  toolbar: {
    backgroundColor: AppConstants.colors.accent2Color,
  },
  appBar: {
    height: 48,
    color: 'white',
    textColor: AppConstants.colors.primary1Color,
  },
  textField: {
    errorColor: AppConstants.colors.accent1Color,
  },
  tableRow: {
    textColor: fade('rgba(0,0,0,1)', 0.54),
  },
  stepper: {
    connectorLineColor: 'rgb(220, 220, 220)',
  }
});

// we currently wrap the themeprovider in another theme provider to add support for the 1.X branch of material-ui
// along-side the 0.X branch.
const HubTheme = ({children}) => (
  <NewMuiThemeProvider theme={muiThemeNew}>
    <MuiThemeProvider muiTheme={muiTheme}>
      {children}
    </MuiThemeProvider>
  </NewMuiThemeProvider>
);

HubTheme.propTypes = {
  children: PropTypes.any,
}

export default HubTheme;



// WEBPACK FOOTER //
// ./src/theme.js